import { useEffect, useState } from "react";
import { hasPermission } from "./PermissoesFuncoes";

interface PermissionWrapperProps {
  requiredPermissions: string[];
  delegate?: any;
  children: (permissions: Record<string, boolean>, delegate?: any) => JSX.Element;
}

/**
 * PermissionWrapper garante que o conteúdo só será renderizado
 * depois que as permissões forem carregadas.
 */
export function PermissionWrapper({ requiredPermissions, delegate, children }: PermissionWrapperProps) {
  const [permissions, setPermissions] = useState<Record<string, boolean> | null>(null);

  useEffect(() => {
    async function loadPermissions() {
      const perms = await hasPermission(requiredPermissions);
      setPermissions(perms);
    }
    loadPermissions();
  }, [requiredPermissions]);

  // enquanto carrega, não renderiza nada
  if (!permissions) return null;

  return children(permissions, delegate);
}
